import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const variantClass = {
  primary: "ev-btn--primary",
  secondary: void 0,
  ghost: "ev-btn--ghost",
  danger: "ev-btn--danger"
};
const Button = React.forwardRef(function Button2({
  variant = "secondary",
  size = "default",
  block = false,
  loading = false,
  iconStart,
  iconEnd,
  type = "button",
  className,
  onClick,
  children,
  "aria-busy": ariaBusy,
  ...rest
}, ref) {
  const handleClick = (event) => {
    if (loading) {
      event.preventDefault();
      return;
    }
    onClick?.(event);
  };
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ref,
      type,
      className: cx("ev-btn", variantClass[variant], size === "floor" && "ev-btn--floor", block && "ev-btn--block", className),
      "data-loading": loading ? "true" : void 0,
      "aria-busy": ariaBusy ?? (loading ? true : void 0),
      onClick: handleClick,
      ...rest,
      children: [
        iconStart != null && iconStart !== false ? /* @__PURE__ */ jsx("span", { className: "ev-btn__icon", "aria-hidden": "true", children: iconStart }) : null,
        children,
        iconEnd != null && iconEnd !== false ? /* @__PURE__ */ jsx("span", { className: "ev-btn__icon", "aria-hidden": "true", children: iconEnd }) : null
      ]
    }
  );
});
Button.displayName = "Button";
export {
  Button
};
//# sourceMappingURL=Button.js.map
